import React, { Fragment, useEffect, useState } from "react";
import { InfoCircleTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import moment from "moment";
import {
  setTableListData,
  setTableActionDetails,
} from "../../actions/tableListing/tableListDataAction";

const LogisticDeliveredTab = ({
  tabTableData,
  isLoading,
  OnhandleTableSortColumn,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isO2WPage =
    window.location.pathname.split("/")[1] === "dashboard" ? true : false;

  const tableSorting = useSelector(
    (state) => state.TableSortingData.tableListData
  );

  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);

  useEffect(() => {
    if (tabTableData.logisticsDeliveredTab?.length > 0) {
      setTotalRecords(tabTableData.totalRecords);
      setPageNo(Number(tabTableData.currentPage));
      dispatch(setTableListData(tabTableData.logisticsDeliveredTab));
    } else {
      setTotalRecords(0);
      setPageNo(1);
    }
  }, [tabTableData.logisticsDeliveredTab]);

  /// table sorting code with pagination
  const handleTableAscDes = (pagination, filters, sorter) => {
    const sortOrder = sorter.order;
    const sortField = sorter.field;
    OnhandleTableSortColumn({
      sortColumn: sortField,
      orderBy:
        sortOrder === "ascend"
          ? "asc"
          : sortOrder === "descend"
          ? "desc"
          : "asc",
      currentPage: pagination.current,
    });
  };

  /// handle overview Details page code
  const handleOverviewDetailsPage = (rowData) => {
    dispatch(
      setTableActionDetails({
        labelId: rowData.customer_PO_Number,
        valueName: rowData.customer_PO_Number,
        SapOrderNumber: rowData.sap_Order_Number,
      })
    );
    navigate(
      `/${
        isO2WPage ? "o2w" : "logistic"
      }/overviewDetails/Delivered/${encodeURIComponent(
        rowData.customer_PO_Number
      )}`
    );
  };

  const tableColumns = [
    {
      title: "Customer Name",
      dataIndex: "customer_Organization_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 250,
      render: (_i, row) => {
        return (
          <div>
            {row.customer_Organization_Name
              ? row.customer_Organization_Name
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Customer Number",
      dataIndex: "customer_Organization_Code",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "customer_Organization_Code"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>{row.customer_Organization_Code ? row.customer_Organization_Code : "N/A"}</div>;
      },
    },
    {
      title: "Shipping Line Name",
      dataIndex: "shipping_Line_Name",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "shipping_Line_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>{row.shipping_Line_Name ? row.shipping_Line_Name : "N/A"}</div>;
      },
    },
    {
      title: "Delivery Number",
      dataIndex: "delivery_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "delivery_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>{row.delivery_Number ? row.delivery_Number : "N/A"}</div>;
      },
    },
    {
      title: "Estimated Delivery Date",
      dataIndex: "delivery_Date_Estimated",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "delivery_Date_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 220,
      render: (_i, row) => {
        return (
          <div>
            {row.delivery_Date_Estimated
              ? moment(row.delivery_Date_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Actual Delivery Date",
      dataIndex: "delivery_Date_Actual",
      sorter: true,
      showSorterTooltip: false,
      width: 200,
      sortOrder:
        tableSorting.sortColumn === "delivery_Date_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.delivery_Date_Actual
              ? moment(row.delivery_Date_Actual).format("DD-MM-YYYY")
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Sales Order No.",
      dataIndex: "sap_Order_Number",
      sorter: true,
      showSorterTooltip: false,
      width: 180,
      sortOrder:
        tableSorting.sortColumn === "sap_Order_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            {row.sap_Order_Number
              ? row.sap_Order_Number
              : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "invoice_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 150,
      render: (_i, row) => {
        return <div>{row.invoice_Number ? row.invoice_Number : "N/A"}</div>;
      },
    },
    {
      title: "Dispatch Quantity",
      dataIndex: "dispatch_Qty",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Qty"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>{row.dispatch_Qty ? row.dispatch_Qty : "N/A"}</div>;
      },
    },
    {
      title: "Estimated Dispatch Date",
      dataIndex: "dispatch_Estimated",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 200,
      render: (_i, row) => {
        return <div>
            {row.dispatch_Estimated
              ? moment(row.dispatch_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
      },
    },
    {
      title: "Actual Dispatch Date",
      dataIndex: "dispatch_Actual",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "dispatch_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 200,
      render: (_i, row) => {
        return <div>
            {row.dispatch_Actual
              ? moment(row.dispatch_Actual).format("DD-MM-YYYY")
              : "N/A"}
          </div>
      },
    },
    {
      title: "Estimated BL/LR Date",
      dataIndex: "bL_LR_Date_Estimated",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "bL_LR_Date_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 200,
      render: (_i, row) => {
        return <div>
            {row.bL_LR_Date_Estimated
              ? moment(row.bL_LR_Date_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
      },
    },
    {
      title: "Actual BL/LR Date",
      dataIndex: "bL_LR_Date_Actual",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "bL_LR_Date_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>
            {row.bL_LR_Date_Actual
              ? moment(row.bL_LR_Date_Actual).format("DD-MM-YYYY")
              : "N/A"}
          </div>
      },
    },
    {
      title: "Estimated time of Arrival",
      dataIndex: "etA_Port_Estimated",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "etA_Port_Estimated"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 220,
      render: (_i, row) => {
        return <div>
            {row.etA_Port_Estimated
              ? moment(row.etA_Port_Estimated).format("DD-MM-YYYY")
              : "N/A"}
          </div>
      },
    },
    {
      title: "Actual Time of Arrival",
      dataIndex: "etA_Port_Actual",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "etA_Port_Actual"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 180,
      render: (_i, row) => {
        return <div>
            {row.etA_Port_Actual
              ? moment(row.etA_Port_Actual).format("DD-MM-YYYY")
              : "N/A"}
          </div>
      },
    },
    {
      title: "Container",
      dataIndex: "container_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "container_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 150,
      render: (_i, row) => {
        return <div>
            {row.container_Number
              ? row.container_Number
              : "N/A"}
          </div>
      },
    },
    {
      title: "BL/LR Number",
      dataIndex: "bL_LR_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "bL_LR_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 150,
      render: (_i, row) => {
        return <div>
            {row.bL_LR_Number
              ? row.bL_LR_Number
              : "N/A"}
          </div>
      },
    },
    {
      title: "Truck Number",
      dataIndex: "truck_Number",
      sorter: true,
      showSorterTooltip: false,
      sortOrder:
        tableSorting.sortColumn === "truck_Number"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      width: 150,
      render: (_i, row) => {
        return <div>
            {row.truck_Number
              ? row.truck_Number
              : "N/A"}
          </div>
      },
    },
    {
      title: "Material Number",
      dataIndex: "material_SAP_Code",
      sorter: true,
      showSorterTooltip: false,
      width: 160,
      sortOrder:
        tableSorting.sortColumn === "material_SAP_Code"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            <label>
              {row.material_SAP_Code ? row.material_SAP_Code : "N/A"}
            </label>
          </div>
        );
      },
    },
    {
      title: "Material Name",
      dataIndex: "material_Name",
      sorter: true,
      showSorterTooltip: false,
      width: 240,
      sortOrder:
        tableSorting.sortColumn === "material_Name"
          ? tableSorting.orderBy === "asc"
            ? "ascend"
            : "descend"
          : null,
      render: (_i, row) => {
        return (
          <div>
            <label>
              {row.material_Name ? row.material_Name : "N/A"}
            </label>
          </div>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 80,
      fixed: "right",
      render: (_i, row) => (
        <div
          className="tbl_info_details"
          onClick={() => handleOverviewDetailsPage(row)}
        >
          <InfoCircleTwoTone />
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <Table
        bordered
        scroll={{ x: 900 }}
        className="logistic_tables"
        dataSource={tabTableData.logisticsDeliveredTab}
        loading={isLoading}
        onChange={handleTableAscDes}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "even-row" : "odd-row"
        }
        pagination={{
          total: totalRecords,
          pageNo: pageNo,
          pageSize: 10,
          responsive: true,
          showSizeChanger: false,
          current: pageNo,
          onChange: (pageNum) => setPageNo(pageNum),
        }}
        columns={tableColumns}
        rowStyle={(record, index) => ({
          backgroundColor: index % 2 === 0 ? "red" : "#ffffff",
        })}
      />
    </Fragment>
  );
};

export default LogisticDeliveredTab;
